import { render, staticRenderFns } from "./FederationTableModal.vue?vue&type=template&id=573fb2cd&"
import script from "./FederationTableModal.vue?vue&type=script&lang=js&"
export * from "./FederationTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports